import sysLocalStorage, { enStorageName } from '../localStorage'
import { Module, mapState } from 'vuex'
import { GetterTree, ActionTree, MutationTree } from 'vuex'
import { RootState } from '../types'
import { login, logout } from '@/api/common/auth'
import { getMenus, getTodoMsg, getAuth, UserData, emptyUser } from '@/api/systemManage/user'

export interface UserState {
    todoCount: number,
    todoList: any[],
    menus: any[],
    accessList: string[],
    userInfo: UserData
}

export const state: UserState = {
    todoCount: 0,
    todoList: [],
    menus: [],
    accessList: [],
    userInfo: emptyUser
}

const mutations: MutationTree<UserState> = {
    SET_TODOLIST: (mState, todoList) => {
        mState.todoList = todoList
    },
    SET_TODOCOUNT: (mState, todoCount) => {
        mState.todoCount = todoCount
    },
    SET_MENUS: (mState, menus) => {
        mState.menus = menus
    },
    SET_ACCESSLIST: (mState, list) => {
        mState.accessList = list
    },
    SET_USERAUTH: (mState, userInfo) => {
        mState.userInfo = userInfo
    }
}

const actions: ActionTree<UserState, RootState> = {
    // 登录
    Login({ commit },  data) {
        return new Promise((resolve, reject) => {
            login(data).then((msg: any) => {
                // if (!msg.IsError) {
                //     var data = msg.MsgObj//JSON.parse()
                // }
                resolve(msg)
            }).catch((error: any) => {
                console.log('login error', error)
                reject(error)
            })
        })
    },
    // 登出
    LogOut({ commit }) {
        return new Promise<void>((resolve, reject) => {
            logout()
            commit('SET_TODOLIST', '')
            commit('SET_TODOCOUNT', 0)
            commit('SET_MENUS', '')
            commit('SET_ACCESSLIST', '')
            commit('SET_USERAUTH', '')
            resolve()
        })
    },
    // 前端 登出
    FedLogOut({ commit }) {
        return new Promise<void>(resolve => {
            logout()
            resolve()
        })
    },
    SetTodo({ commit }) {
        commit('SET_TODOLIST', '')
        commit('SET_TODOCOUNT', 0)
        const snTodos = 'TodoList'
        const snTodoNum = 'TodoNums'
        const storeList = sysLocalStorage.getItem(snTodos)
        const storeCount = sysLocalStorage.getItem(snTodoNum)
        if (storeList && storeCount) {
            commit('SET_TODOLIST', JSON.parse(storeList))
            commit('SET_TODOCOUNT', storeCount)
        } else {
            getTodoMsg().then((response: { data: any }) => {
                var data = response.data
                if (data) {
                    var list = data.items
                    sysLocalStorage.setItem(snTodos, JSON.stringify(list))
                    commit('SET_TODOLIST', list)
                    var count = data.totalRecord
                    sysLocalStorage.setItem(snTodoNum, count)
                    commit('SET_TODOCOUNT', count)
                }
            })
        }
    },
    SetMenu({ commit }) {
        commit('SET_MENUS', '')
        commit('SET_ACCESSLIST', '')
        const snMenus = enStorageName[enStorageName.Menus]
        const menuStr = sysLocalStorage.getItem(snMenus)
        if (menuStr) {
            commit('SET_MENUS', JSON.parse(menuStr))
            const list = getAccessList(JSON.parse(menuStr))
            commit('SET_ACCESSLIST', list)
        } else {
            getMenus().then((response: { data: any }) => {
                var data = response.data
                if (data) {
                    sysLocalStorage.setItem(snMenus, JSON.stringify(data))
                    commit('SET_MENUS', data)
                    const list = getAccessList(data)
                    commit('SET_ACCESSLIST', list)
                }
            })
        }
    },
    SetUserAuth({ commit }) {
        commit('SET_USERAUTH', '')
        const snAuth = enStorageName[enStorageName.UserAuth]
        const str = sysLocalStorage.getItem(snAuth)
        if (str) {
            commit('SET_USERAUTH', JSON.parse(str))
        } else {
            getAuth().then((response: { data: any }) => {
                sysLocalStorage.setItem(snAuth, JSON.stringify(response.data))
                commit('SET_USERAUTH', response.data)
            })
        }
    }
}
const getAccessList = (menus: any[]): string[] => {
    let list: string[] = []
    menus.forEach((e: any, i: number) => {
        if (e.Path != "#") {
            list.push(e.Path)
        }
        if (e.Children) {
            e.Children.forEach((s: any, index: number) => {
                if (s.Path != "#") {
                    list.push(s.Path)
                }
            })
        }
    })
    return list
}
const getters: GetterTree<UserState, RootState> = {
    todoCount: mState => mState.todoCount,
    todoList: mState => mState.todoList,
    menus: mState => mState.menus,
    accessList: mState => mState.accessList,
    userInfo: mState => mState.userInfo
}

const namespaced: boolean = true

export const user: Module<UserState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
}
